// Gedeeld met de backend: shared/schema.json (tabellen en velden) en shared/permissions.json (rechten).
import schemaJson from "@shared/schema.json";
import permissionsJson from "@shared/permissions.json";
import type { TableKey } from "./types";

export interface FieldDef {
  name: string;
  type: "text" | "longtext" | "email" | "phone" | "url" | "number" | "currency" | "date" | "datetime" | "select" | "link";
  choices?: string[];
  table?: TableKey;
  precision?: number;
}

export interface TableDef {
  name: string;
  primary: string;
  fields: FieldDef[];
}

export const SCHEMA = schemaJson as { tables: Record<TableKey, TableDef> };

export interface PermissionCatalog {
  permissions: { key: string; label: string; group: string }[];
  roles: { key: string; label: string; permissions: string[] }[];
  actions: Record<string, string>;
  tables: Record<string, string>;
  fieldGuards: Record<string, Record<string, string>>;
}

export const PERMISSIONS = permissionsJson as PermissionCatalog;

export const roleLabel = (role: string) => PERMISSIONS.roles.find((r) => r.key === role)?.label ?? role;
